var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('monaco',{attrs:{"language":"lua","code":_vm.code},on:{"mounted":_vm.editorMounted}}),_vm._v(" "),_c('button',{staticClass:"run",on:{"click":_vm.exeLua}},[_vm._v("Run script")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }